/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import truncate from 'base-ui/dist/underline/truncate';
import NavLink from 'components/NavLink';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

function Crumb({ links, options, idx }) {
  const nextIdx = idx + 1;
  const url = new URL(links[idx].url);
  let link = null;

  if (url.pathname !== '/') {
    link = url.pathname;
  }

  return links.length - 1 === nextIdx ? (
    <span className={'breadcrumb_last'}>
      {links[idx].text}
    </span>
  ) : (
    <>
      {link ? (
        <NavLink
          basePath={publicRuntimeConfig.PUBLIC_URL}
          as={`${link}`}
          to={`/category?permalink=${link}`}
          routerStrategy={'next'}
          className={(links.length - 1) === nextIdx ? 'breadcrumb_last' : ''}
        >
          {truncate(links[idx].text, 30)}
        </NavLink>
      ) : (
        <NavLink
          basePath={publicRuntimeConfig.PUBLIC_URL}
          as={`${link || '/'}`}
          to="/"
          routerStrategy={'next'}
          className={(links.length - 1) === nextIdx ? 'breadcrumb_last' : ''}
        >
          {links[idx].text}
        </NavLink>
      )}

      {(links.length - 1) > nextIdx && (
        <React.Fragment>
          {` ${options.sep} `}
          <Crumb links={links} options={options} idx={nextIdx} />
        </React.Fragment>
      )}
    </>
  );
}

Crumb.propTypes = {
  links: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
  idx: PropTypes.number.isRequired,
};

const Breadcrumbs = ({ breadcrumbs, className }) => (
  <div id="breadcrumbs" className={className}>
    <Crumb links={breadcrumbs.links} options={breadcrumbs.options} idx={0} />
  </div>
);

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.object.isRequired,
  className: PropTypes.string
};

Breadcrumbs.defaultProps = {
  className: ''
};

export default Breadcrumbs;
